import React, {useEffect, useState} from "react";
import MUIDataTable from "mui-datatables";
import Loader from "../../Loader";
import moment from "moment";
import { GetLogs } from "../../redux/Actions/userStatusService";
import { useDispatch } from "react-redux";

const ActivityTable = () => {
 
  const userInfo = localStorage.getItem("userInfo");
  const role = userInfo ? JSON.parse(userInfo).portal : null; // Safely parse and access portal
  const id = userInfo ? JSON.parse(userInfo).id : null; // Safely parse and access portal
  const dispatch= useDispatch()
 
  const [ActivityValue, setActivityValue] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPortal = async () => {
      try {
        const response = await dispatch(GetLogs({role, id}));
        setActivityValue(response.payload.data); 
      } catch (error) {
        console.error("Error fetching portal:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPortal();
  }, []);

 
  const columns = [
    {
      name: "serviceName",
      label: "Service Name",
      options: {
        filter: true,
      },
    },
    {
      name: "reason",
      label: "Reason",
      options: {
        filter: true,
        setCellProps: () => ({
          style: {
            whiteSpace: "normal",
            wordBreak: "break-word",
            overflowWrap: "anywhere",
            maxWidth: 600,
          },
        }),
       
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        customBodyRender: (value) => {
          const normalized = String(value || '').toLowerCase();
          let backgroundColor;
          let textColor;

          if (normalized === 'success' || normalized === 'succeeded') {
            backgroundColor = '#e6f4ea';
            textColor = '#1e7e34';
          } else if (
            normalized === 'failed' ||
            normalized === 'failure' ||
            normalized === 'error'
          ) {
            backgroundColor = '#fdecea';
            textColor = '#b00020';
          }

          if (!backgroundColor) return value;

          return (
            <span
              style={{
                display: 'inline-block',
                padding: '2px 8px',
                borderRadius: 6,
                backgroundColor,
                color: textColor,
                fontWeight: 600,
                lineHeight: 1.4,
              }}
            >
              {value}
            </span>
          );
        },
      },
    },
    {
      name: "createdAt",
      label: "Created At",
      options: {
        filter: true,
        customBodyRender: (value) => {
          return new Date(value).toLocaleString(); // Format date
        },
      },
    },
  ];

  const options = {
    filter: true,
    responsive: "standard",
    selectableRows: "none",
    pagination: false,
    tableBodyHeight: "60vh",
    tableBodyMaxHeight: "60vh",
  };
  
  return (
    <>
    {loading ? (
      <Loader /> // Show loader while fetching data
    ) : (
      <MUIDataTable
        title={"Activity Logs"}
        data={ActivityValue.map(log => ({
          serviceName: log.serviceName,
          reason: log.reason,
          status: log.status,
          createdAt: log.createdAt,
        }))}
        columns={columns}
        options={options}
      />
    )}
  </>
  );  
};

export default ActivityTable;

